module.exports = __webpack_public_path__ + "img/payid.649a756c.png";